export function getTotalNameplateVoltageForFrequencyV(
  motorRerateV: number,
  pumpHz: number
): number {
  return motorRerateV * (pumpHz / 60);
}

export function get50HzNameplate(value: number | undefined | null): number {
  return value ? Math.round(value * (5 / 6)) : 0;
}

/**
 * Returns the elevation-based HP derate factor for HPS motors.
 * Below or at 3280 ft ASL the factor is 1.0 (no derate).
 * Above 3280 ft: factor = ( 1- ( ( Elevation - 3280.839895 ) / 328.0839895 ) * 0.01 )
 */
export function getMotorElevationDerateFactor(
  elevationFt: number | null | undefined
): number {
  if (!elevationFt || elevationFt <= 3280.839895) return 1;
  return 1 - ((elevationFt - 3280.839895) / 328.0839895) * 0.01;
}
